<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
  >
    
    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <ExitStorageAdjustmentNew
        @entry-created="entryCreated"
        modelNameSingular="Perda em Estufa"
        :isLoss="true"
    />
    </template> 


    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <ExitStorageAdjustmentEdit
        :entry="item"
        :readOnly="true"
        :isLoss="true"
        modelNameSingular="Perda em Estufa"
      />    
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <ExitStorageAdjustmentEdit
        :entry="item"
        @entry-updated="entryUpdated"
        :isLoss="true"
        modelNameSingular="Perda em Estufa"
        :isEdit="true"
      />     
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <ExitStorageAdjustmentDelete
        :entry="item"
        :isLoss="true"
        @entry-destroyed="entryDeleted"
        modelNameSingular="Perda em Estufa"
      />     
      </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import ExitStorageAdjustmentNew from "@models/storages/storage_adjustments/exit_storage_adjustments/new.vue";
import ExitStorageAdjustmentEdit from "@models/storages/storage_adjustments/exit_storage_adjustments/edit.vue";
import ExitStorageAdjustmentDelete from "@models/storages/storage_adjustments/exit_storage_adjustments/delete.vue";

export default {
  data() {
    return {
      dialogModel: false,
      exitStorageAdjustmentNewDialog: false,
      entryStorageAdjustmentNewDialog: false,
      indexItems: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      tableHeaders: [
        //trocar id para code depois que vier a coluna
        { text: "Código", align: "left", sortable: true, value: "code" },
        { text: "Data", align: "left", sortable: true, value: "date" },
        { text: "Estufa", align: "left", sortable: true, value: "storage.name" },
        { text: "Motivo", align: "left", sortable: true, value: "stockAdjustmentReason.name" },
        { text: "Tipo de Perda", align: "left", sortable: true, value: "adjustmentTypeText", filter_value: "isStockEntryType" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'date', mask: 'date'},
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Perdas em Estufa"
    },
    modelNamePlural: {
      type: String,
      default: "Perdas em Estufas"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    ExitStorageAdjustmentNew: ExitStorageAdjustmentNew,
    ExitStorageAdjustmentEdit: ExitStorageAdjustmentEdit,
    ExitStorageAdjustmentDelete: ExitStorageAdjustmentDelete,
  },
  created() {
    // this.loadServerEntries();
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_STORAGE_ADJUSTMENTS,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // this.fields = response.data.groundContext.fieldsIndex.fields;
          //console.log("All fields", this.fields);
          this.indexItems = response.data.accountContext.lossesIndex.stockAdjustments; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.totalItems = response.data.accountContext.lossesIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.accountContext.lossesIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.accountContext.lossesIndex.serverFields; // seta os campos que podem ser filtrados
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
    exitStorageAdjustmentOpenAction: function() {
      if (this.$refs.exitStorageAdjustmentNewRef) {
        if (this.$refs.exitStorageAdjustmentNewRef.$refs.baseNew) {
          this.$refs.exitStorageAdjustmentNewRef.$refs.baseNew.openAction();
          this.dialogCancelAction();
        }
      }
    },
    entryStorageAdjustmentOpenAction: function() {
      if (this.$refs.entryStorageAdjustmentNewRef) {
        if (this.$refs.entryStorageAdjustmentNewRef.$refs.baseNew) {
          this.$refs.entryStorageAdjustmentNewRef.$refs.baseNew.openAction();
          this.dialogCancelAction();
        }
      }
    },
    dialogOpenAction: function() {
      // console.log("dialogOpenAction");
    },
    dialogCancelAction: function() {
      // console.log("dialogCancelAction");
      this.dialogModel = false;
    },
  }
};

const LOAD_ALL_STORAGE_ADJUSTMENTS = gql `
  query($input: IndexInputObject!) {
    accountContext {
      lossesIndex(input: $input){
        count
        typeOperators
        serverFields      
        stockAdjustments {
          id
          code
          date
          adjustmentTypeText
          isStockEntryType
          storage {
            name
          }
          stockAdjustmentReason {
            name
          }
          canBeDeleted
          undeletabilityReasons
        }
      }
    }
  }
`;

</script>

<style scoped></style>
